import { Popover as TailwindPopover, Transition } from "@headlessui/react";
import { IoChevronDown } from "react-icons/io5";
import { Fragment } from "react";

const Popover = ({ title, items }) => {
  return (
    <TailwindPopover className="relative">
      {({ open }) => (
        <>
          <TailwindPopover.Button className="inline-flex items-center font-sm text-gray-400">
            <span className="mr-3 hidden md:block">{title}</span>
            <IoChevronDown />
          </TailwindPopover.Button>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <TailwindPopover.Panel className="absolute z-10 mt-5 transform px-2 w-48 max-w-15 sm:px-0 lg:ml-0 lg:left-1/2 -translate-x-full md:-translate-x-3/4">
              <div className="rounded-lg shadow-sm ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div className="relative grid gap-0 bg-white">
                  {items &&
                    items.map((item) => {
                      return item.content;
                    })}
                </div>
              </div>
            </TailwindPopover.Panel>
          </Transition>
        </>
      )}
    </TailwindPopover>
  );
};

export default Popover;
